import styled from 'styled-components';

export const HeaderContainer = styled.header`
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1000;

    width: 100%;
    height: 12rem;

    background: #f5f5f5;
    border-bottom: 1px solid #ddd;

    --color-primary: #000;

    .to-desktop {
        display: block !important;
    }
    .to-mobile {
        display: none !important;
    }

    .bar-top {
        width: 100%;

        .content {
            display: flex;
            align-items: center;
            justify-content: flex-end;

            height: 4rem;

            border-bottom: 1px solid #ddd;

            span {
                font-size: 1.2rem;
                margin-right: 2rem;

                a:hover {
                    transition: .2s;
                    color: var(--color-primary);
                }
            }

            .social {
                display: flex;

                a {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    
                    width: 2rem;
                    height: 2rem;
                    font-size: 1.4rem;

                    + a {
                        margin-left: .5rem;
                    }

                    i {
                        transition: .2s;
                    }

                    &:hover {
                        i {
                            color: var(--color-primary);
                        }
                    }
                }
            }
        }
    }

    > .content {
        display: flex;
        align-items: center;
        justify-content: space-between;

        height: 8rem;

        a.logo {
            display: block;
            height: 4rem;

            img {
                height: 100%;
            }            
        }

        nav {
            ul {
                display: flex;

                list-style: none;

                li {
                    position: relative;
                    min-width: 100px;
                    height: 8rem;
                
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    + li {
                        margin-left: 1.8rem;
                    }

                    a, span {
                        position: relative;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        
                        width: 100%;
                        font-size: 1.4rem;
                        font-weight: bold;
                        
                        transition: color .3s;
                        cursor: pointer;

                        i {
                            font-size: 1.2rem;
                            margin-left: .7rem;
                        }
                        
                        &::before {
                            position: absolute;
                            content: '';
                            left: 50%;
                            bottom: 0;
                            
                            height: 2px;
                            width: 100%;
                        
                            background: linear-gradient(90deg, var(--nooio-gradient));
                        
                            transform: translate(-50%);
                        
                            opacity: 0;
                        }

                        &:hover, &.active {
                            height: 8rem;
                            color: #000;
                            transition: .3s;

                            // padding-bottom: 1rem;

                            &::before {
                                opacity: 1;
                                transition: .3s;
                            }
                        }
                    }
                }
            }
        }

        .buttons {
            display: flex !important;
        }
    }

    #menu-dropdown {
        position: absolute;
        bottom: -.5px;
        left: 0;
        transform: translateY(100%);

        width: 100%;
        min-height: calc(100vh - 12rem);

        // border-top: 1px solid #ddd;
        background: rgba(0, 0, 0, .5);

        & {
            transform: translateY(100%) scale(0);
            pointer-events: none;

            &.active {
                transform: translateY(100%) scale(1);
                pointer-events: auto;
            }

            .dropdown-content {
                opacity: 0;
                transition: .5s;

                &.active {
                    opacity: 1;
                }
            }
        }

        .wrapper {
            width: 100%;

            .dropdown-content {
                min-height: 50rem;

                background: rgba(255, 255, 255, 0.9);

                .content {
                    padding: 5rem 0;

                    h3 {
                        position: relative;
                        font-size: 1.4rem;
                        color: var(--color-text);
                        margin-bottom: 1.3rem;
                        padding-bottom: 1rem;

                        &::after {
                            position: absolute;
                            content: '';
                            bottom: 0;
                            left: 0;

                            width: 3rem;
                            height: .1rem;

                            background: #000;
                        }
                    }

                    h2 {
                        font-size: 2.2rem;

                        margin-bottom: 5rem;
                    }

                    .grid-products {
                        display: grid;
                        grid-template-columns: repeat(3, 30rem);
                        gap: 4rem;

                        .product {
                            display: flex;
                            padding: 1.5rem;

                            width: 100%;
                            min-height: 9rem;
                            border-radius: 1rem;

                            img {
                                width: 6rem;
                                height: 6rem;

                                object-fit: contain;
                            }

                            .text {
                                display: flex;
                                flex-direction: column;
                                width: 100%;

                                margin-left: 1.5rem;

                                strong {
                                    margin-bottom: .2rem;
                                    
                                    font-size: 1.6rem;
                                    font-weight: bold;
                                    color: var(--color-title);
                                }

                                span {
                                    font-size: 1.4rem;
                                }
                            }

                            &:hover {
                                transform: scale(1.03);
                                transition: .2s;
                                background: #fff;
                            }

                        }
                    }
                }
            }
        }
    }

    @media (max-width: 540px) {
        height: 27.77778vw;

        .to-desktop {
            display: none !important;
        }
        .to-mobile {
            display: block !important;
        }

        .bar-top {
            .content {
                justify-content: space-between;

                height: 9.72222vw;

                span {
                    font-size: 2.77778vw;
                    margin-right: 5.55556vw;
                }

                .social {
                    a {
                        width: 5.55556vw;
                        height: 5.55556vw;

                        font-size: 3.33333vw;

                        + a {
                            margin-left: 0;
                        }
                    }
                }
            }
        }

        > .content {
            overflow: hidden;

            height: 18.05556vw;

            a.logo {
                height: 6.94444vw;
            }

            nav {
                position: absolute;
                bottom: 0;
                left: 0;
                transform: translateY(100%);

                width: 100%;
                height: calc(100vh - 18.05556vw);
                
                background: rgba(0, 0, 0, 0.705);
                border-top: 0.27778vw solid #ddd;
                border-bottom: 0.27778vw solid #ddd;

                & {
                    opacity: 0;
                    transform: scaleY(0);
                    transform-origin: top;
                    transition: opacity .3s, transform .15s;
                    pointer-events: none;

                    &.active {
                        pointer-events: auto;
                        opacity: 1;
                        transform: translateY(100%) scaleY(1);
                    }
                }

                ul {
                    flex-direction: column;

                    height: 100%;
                    padding: 11.11111vw 5% 16.66667vw;

                    background: #fff;   

                    li {
                        justify-content: flex-start;
                        
                        min-width: unset;
                        height: 13.88889vw;
                        
                        &::before {
                            position: absolute;
                            content: '';
                            top: 50%;
                            left: 0;
                            
                            height: 0.83333vw;
                            width: 3.33333vw;
                        
                            background: linear-gradient(90deg, var(--nooio-gradient));
                        
                            transform: translateY(-50%) scaleX(0);
                        }
                        
                        &.active {
                            &::before {
                                transform: translateY(-50%) scaleX(1);
                            }

                            a {
                                transform: translateX(5.55556vw);
                            }
                        }

                        + li {
                            margin-left: 0;
                            border-top: 0.27778vw solid rgba(221, 221, 221, 0.568);
                        }

                        a, span {
                            justify-content: flex-start;
                            display: inline-block;
                            
                            line-height: 13.88889vw;

                            font-size: 3.88889vw;

                            &::before {
                                content: none;
                            }
                            
                            &:hover, &.active {
                                height: unset;
                            }
                        }
                    }

                    .buttons-m {
                        display: flex !important;
                        flex-direction: column;
                        align-items: center;

                        margin-top: 8.33333vw;

                        .button {
                            width: 100%;

                            + .button {
                                margin-left: 0px;
                                margin-top: 20px;
                            }
                        }
                    }
                }
            }

            #toggle {
                position: relative;
                display:flex !important;
                flex-direction:column;
                // align-items: center;
                // justify-content: center;

                width: 70px;
                transform: scale(.3) rotate(180deg) translateX(-70px);

                span{
                    background: #000;

                    border-radius:10px;
                    height:7px;
                    margin: 7px 0;

                    transition: .4s  cubic-bezier(0.68, -0.6, 0.32, 1.6);
                    
                    &:nth-child(1){
                        width:50%;
                    }
                    
                    &:nth-child(2){
                        width:100%;
                    }
                    
                    &:nth-child(3){
                        width:75%;
                    }
                    
                }
                
                &.active span:nth-child(1){
                    transform-origin:bottom;
                    transform:rotateZ(45deg) translate(8px,0px);
                    // width: 100%;
                }
                
                &.active span:nth-child(2){
                    transform-origin:top;
                    transform:rotateZ(-45deg)
                }
                
                &.active span:nth-child(3){
                    transform-origin:bottom;
                    width:50%;
                    transform: translate(30px,-11px) rotateZ(45deg);
                }
                
            }

            .buttons {
                display: none !important;
            }
        }
    }
`;
